export { AtnFilterSlideoutComponent as Component } from './filter-slideout.component'
